// extracted by mini-css-extract-plugin
export default {"root":"InvoicesRow_root__BdwHm","date":"InvoicesRow_date__rb+Ew","contactName":"InvoicesRow_contactName__WRNWu"};